export default __webpack_public_path__ + "static/media/united-kingdom.2d19fed4.svg";